exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link {\r\n    cursor: pointer;\r\n}\r\n\r\nli .nav-dropdown-items {\r\n    padding-left: 20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-sidebar/app-sidebar.component.css
// module id = ../../../../../src/app/components/app-sidebar/app-sidebar.component.css
// module chunks = main